import { auth } from '@/auth';
import { createFileRoute } from '@tanstack/react-router';
import { ForgotPasswordForm } from 'ht-sdk/auth/client';

export const Route = createFileRoute('/forgot-password')({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<div className="flex size-full min-h-screen items-center justify-center bg-gray-100">
			<div className="w-lg rounded-2xl border border-gray-200 bg-white p-8 shadow-lg">
				<ForgotPasswordForm auth={auth} />
			</div>
		</div>
	);
}
